
import Constant from "@constant/index.js";
require("@util/myCarousel.js");

function harmonyAppRecommend() {
    return new Promise((resolve) => {
        try{
            window?.apputils?.getRecommendationStatus?.((isShowReco) => {
                if (isShowReco === false) {
                    resolve(false);
                } else {
                    resolve(true);
                }
            });
        }catch(e){
            // console.log('app鸿蒙报错',e)
        }
    });
}
export default class RecommendView {
    constructor(model) {
        this._el = $(".recommend_content");
        this._model = model;

        this._model._view = this;
    }

    getRedirectLink(url) {
        if (_terminal == Constant.TERMINAL.PC) {
            return url.pc;
        } else if (_terminal == Constant.TERMINAL.WAP) {
            return url.wap;
        } else {
            return url.pc;
        }
    }

    async render() {
        if(window.apputils.isHarmonyOS || window.apputils.isAPP){
            const harmonyShowRecom = await harmonyAppRecommend();
            if (!harmonyShowRecom) {
                $('.recommend_box').hide();
                return;
            }
        }
        if(this._model._data && this._model._data.length <= 0) {
            $('.recommend_box').hide();
            return;
        }
        let html = "";
        if (this._model._data && this._model._data instanceof Array && this._model._data.length > 0) {
            for (var i = 1; i <= this._model._data.length; i++) {
                if (i % 2 != 0) {
                    html += ` <div class="row">
                    <a href=${this.getRedirectLink(this._model._data[i - 1].url)} class="item" latag="latag_wap_cart_recommendItem_${this._model._data[i - 1].position}_${this._model._data[i - 1].strategy}_${this._model._data[i - 1].goodsCode}" >                    
                        <div class="pic_box">
                            <img src="${this._model._data[i - 1].thumbnail}" alt=""/>
                        </div>
                        <p class="desc">${this._model._data[i - 1].name}</p>
                        <p class="price"><span><b class="mark">¥</b>${this._model._data[i - 1].price.P_C.C_2.P_0.DV.V}</span><i class="fr iconfont icon-bill-wap-cart"></i></p>                    
                    </a>`;
                } else {
                    html += `<a href=${this.getRedirectLink(this._model._data[i - 1].url)} class="item" latag="latag_wap_cart_recommendItem_${this._model._data[i - 1].position}_${this._model._data[i - 1].strategy}_${this._model._data[i - 1].goodsCode}" >                   
                            <div class="pic_box">
                                <img src="${this._model._data[i - 1].thumbnail}" alt=""/>
                            </div>
                            <p class="desc">${this._model._data[i - 1].name}</p>
                            <p class="price"><span><b class="mark">¥</b>${this._model._data[i - 1].price.P_C.C_2.P_0.DV.V}</span><i class="fr iconfont icon-bill-wap-cart"></i></p>
                        </a>
                    </div>`;
                }
            }

            this._el.html($(html));
        } else {
            this._el.hide();
            $('.recommend_box').hide();
        }
        // 鸿蒙控制不显示“为你推荐”模块
        window?.apputils?.getRecommendationStatus?.((isShowReco) => {
          if (isShowReco === false) {
            $('.recommend_box').hide();
          }
        });
    }
}